
interface NursingHomeProps {
  name: string;
  description: string;
  address: {
    streetAddress: string;
    addressLocality: string;
    addressRegion: string;
    postalCode: string;
    addressCountry: string;
  };
  telephone: string;
  url: string;
  imageUrl?: string;
  geo?: {
    latitude: number;
    longitude: number;
  };
  priceRange?: string;
  openingHours?: string;
}

/**
 * Generate LocalBusiness schema for nursing homes
 * Using LocalBusiness which is approved for Review snippets
 */
export function generateNursingHomeSchema(nursingHome: NursingHomeProps) {
  // Ensure absolute URLs
  const absoluteUrl = nursingHome.url.startsWith('http') 
    ? nursingHome.url 
    : `https://www.grandpal.co${nursingHome.url}`;
    
  const imageUrl = nursingHome.imageUrl?.startsWith('http')
    ? nursingHome.imageUrl
    : nursingHome.imageUrl ? `https://www.grandpal.co${nursingHome.imageUrl}` : undefined;

  // Generate unique identifier for the nursing home
  const uniqueId = absoluteUrl;

  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness", // Changed from NursingHome to LocalBusiness which is supported for reviews
    "@id": uniqueId, // Use the URL as a unique identifier
    "name": nursingHome.name,
    "description": nursingHome.description,
    "address": {
      "@type": "PostalAddress",
      ...nursingHome.address
    },
    "telephone": nursingHome.telephone,
    "url": absoluteUrl,
    ...(imageUrl && { "image": imageUrl }),
    ...(nursingHome.geo && {
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": nursingHome.geo.latitude,
        "longitude": nursingHome.geo.longitude
      }
    }),
    "priceRange": nursingHome.priceRange,
    "openingHoursSpecification": nursingHome.openingHours ? {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    } : undefined
  };
}
